import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { MailArt, MailEinstellung, MailEinstellungen } from "@msc/shared";
import { api } from "../lib/api.js";

/** Eigene Abmeldung und Admin-Schalter betreffen dieselbe Liste — beide invalidieren sie. */
export const mailEinstellungenSchluessel = ["mailEinstellungen"] as const;

export function useMailEinstellungen() {
  return useQuery<MailEinstellung[]>({
    queryKey: mailEinstellungenSchluessel,
    queryFn: async () => (await api.get<MailEinstellungen>("/me/mail-einstellungen")).items,
  });
}

export function useSetzeMailAbmeldung() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ art, abgemeldet }: { art: MailArt; abgemeldet: boolean }) =>
      api.put<MailEinstellung>(`/me/mail-einstellungen/${art}`, { abgemeldet }),
    onSettled: () => void qc.invalidateQueries({ queryKey: mailEinstellungenSchluessel }),
  });
}

export function useSetzeAbmeldenErlaubt() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ art, abmeldenErlaubt }: { art: MailArt; abmeldenErlaubt: boolean }) =>
      api.put<{ art: MailArt; abmeldenErlaubt: boolean }>(`/mail-arten/${art}`, { abmeldenErlaubt }),
    onSettled: () => void qc.invalidateQueries({ queryKey: mailEinstellungenSchluessel }),
  });
}
